import React from 'react'

const FlightsManagement:React.FC = () => {
  return (
    <div>FlightsManagement</div>
  )
}

export default FlightsManagement